<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75">
        <md-card>
          <md-card-header data-background-color="purple">
            <div class="md-layout md-alignment-center-space-between">
              <h4 class="title">Admins</h4>
              <div style="display: flex">
                <md-button class="md-icon-button md-dense refresh-btn" @click="showAddNewAdmin = true">
                  <md-tooltip md-direction="top">Add new admin</md-tooltip>
                  <md-icon>person_add</md-icon>
                </md-button>
                <search-box v-model="search" @doSearch="doSearch"></search-box>
                <md-button class="md-icon-button md-dense refresh-btn" @click="fetchAdmins">
                  <md-tooltip md-direction="top">Refresh users</md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>

            <p v-if="totalAdmins === 1" class="category">1 User</p>
            <p v-else class="category">{{ totalAdmins }} Users</p>
          </md-card-header>
          <md-card-content>
            <div>
              <md-table v-model="adminsList" table-header-color="purple" md-card>
                <md-table-row class="cursor-pointer" slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Username">{{ item.username }}</md-table-cell>
                  <md-table-cell md-label="Permissions" class="is-active">
                    <span @click="switchPermission(item.pk, item.groups, 'server_admins')">
                      <md-icon v-if="item.groups.includes('server_admins')">storage</md-icon>
                      <md-icon v-else class="disabled-text">storage</md-icon>

                      <md-tooltip md-direction="top">Server Administration</md-tooltip>
                    </span>

                    <span @click="switchPermission(item.pk, item.groups, 'application_admins')">
                      <md-icon v-if="item.groups.includes('application_admins')">apps</md-icon>
                      <md-icon v-else class="disabled-text">apps</md-icon>

                      <md-tooltip md-direction="top">Applications Administration</md-tooltip>
                    </span>

                    <span @click="switchPermission(item.pk, item.groups, 'viewer_admins')">
                      <md-icon v-if="item.groups.includes('viewer_admins')">preview</md-icon>
                      <md-icon v-else class="disabled-text">preview</md-icon>

                      <md-tooltip md-direction="top">Viewer Application Administration</md-tooltip>
                    </span>
                  </md-table-cell>
                  <md-table-cell md-label="Is active?" class="is-active">
                    <md-icon v-if="item.isActive">done</md-icon>
                    <md-icon v-else>remove</md-icon>
                  </md-table-cell>
                  <md-table-cell md-label="Last Login">
                    <span @click="showLoginAttemptsTriggerFunction(item.id)">
                      {{ item.lastLogin.attemptTime | formatLoginAttemptTime }}
                    </span>
                    <md-tooltip md-direction="top">Click for more information...</md-tooltip>
                  </md-table-cell>
                  <md-table-cell md-label="Actions" class="is-active">
                    <md-button @click="deleteAdmin(item.id)" class="md-icon-button" :disabled="!item.isActive">
                      <md-tooltip md-direction="top">Delete admin</md-tooltip>
                      <md-icon>delete</md-icon>
                    </md-button>
                    <md-button @click="changePassword(item.id)" class="md-icon-button" :disabled="!item.isActive">
                      <md-tooltip md-direction="top">Change Password</md-tooltip>
                      <md-icon>vpn_key</md-icon>
                    </md-button>
                    <md-button
                      class="md-icon-button"
                      v-if="isMFAEnabled"
                      :disabled="!item.isActive || !item.hasOtp"
                      @click="
                        revokeTOTPId = item.id;
                        showRevokeDialog = true;
                      "
                    >
                      <md-tooltip md-direction="top">Revoke Admin TOTP</md-tooltip>
                      <md-icon>timer_off</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <div class="md-layout md-alignment-center">
                <pagination v-model="adminsPage" :page-count="totalPages" @input="changePage"></pagination>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <failure-attempts />
        <md-card>
          <md-card-header data-background-color="orange" class="md-layout">
            <h4 class="title filter-by">
              Filter By
              <md-button class="md-icon-button md-dense" @click="removeFilters('all')" v-if="removeAll">
                <md-icon>clear</md-icon>
              </md-button>
            </h4>
          </md-card-header>
          <md-card-content class="filters">
            <md-list>
              <div v-if="searched">
                <md-subheader class="filter-radio">
                  Search
                  <md-button class="md-icon-button md-dense" @click="removeFilters('search')" v-if="searched">
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="searched" :value="searched">{{ searched }}</md-radio>
              </div>

              <md-subheader class="filter-radio">
                Permission
                <md-button class="md-icon-button md-dense" @click="removeFilters('permission')" v-if="permissionsRadio">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="permissionsRadio" value="application_admins"> Application</md-radio>
              <md-radio v-model="permissionsRadio" value="server_admins"> Server</md-radio>
              <md-radio v-model="permissionsRadio" value="viewer_admins"> Viewer Application Admin</md-radio>

              <md-subheader class="filter-radio">
                Show Deleted Admins
                <md-button
                  class="md-icon-button md-dense"
                  @click="removeFilters('active_only')"
                  v-if="isActive !== true"
                >
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="isActive" :value="true"> Only Active Admins</md-radio>
              <md-radio v-model="isActive" :value="false"> Only Deleted Admins</md-radio>
              <md-radio v-model="isActive" :value="null"> Both Active and Deleted Admins</md-radio>
            </md-list>
          </md-card-content>
        </md-card>
      </div>

      <delete-dialog
        :show="showDeleteDialog"
        delete-api-name="deleteAdmin"
        title="Delete Admin"
        message="This action deletes this admin permanently, Are you sure?"
        :request-body="{ admin_pk: deleteDialogKey }"
        @close="
          showDeleteDialog = false;
          deleteDialogKey = null;
        "
        @deleted="adminDeleted"
      ></delete-dialog>
      <are-you-sure
        :show="showRevokeDialog"
        message="This action revokes the TOTP device for this admin. The admin have to scan new TOTP QRCode at the next login. Are you sure?"
        @approve="
          showRevokeDialog = false;
          revokeTOTP(revokeTOTPId);
        "
        @close="showRevokeDialog = false"
      ></are-you-sure>
      <create-new-admin
        :show="showAddNewAdmin"
        @created="adminCreated"
        @close="showAddNewAdmin = false"
      ></create-new-admin>

      <set-password
        title="Change Password"
        submitBtnText="Change"
        :show="showChangePasswordDialog"
        :adminPk="changePasswordAdminPk"
        @close="showChangePasswordDialog = false"
        @changed="
          showChangePasswordDialog = false;
          notifySuccess('Password successfully changed!');
        "
      ></set-password>

      <login-attempts :attempts="currentLoginAttempts" :show="showLoginAttempts" @close="showLoginAttempts = false">
      </login-attempts>
    </div>
  </div>
</template>
<script>
import { onMounted, onUpdated, ref, computed } from "@vue/composition-api";
import apiManager from "@/api-manager";
import snakeCaseObjectKeysToCamelCase from "@/utils/snakeCaseObjectKeysToCamelCase";
import camelCaseObjectKeysToSnakeCase from "@/utils/camelCaseObjectKeysToSnakeCase";
import DeleteDialog from "@/components/DeleteDialog";
import AreYouSure from "@/components/AreYouSure";
import CreateNewAdmin from "@/components/CreateNewAdmin";
import SearchBox from "@/components/SearchBox";
import SetPassword from "@/components/SetPassword";
import LoginAttempts from "@/components/LoginAttempts";
import { Pagination } from "@/components";
import fetchErrorHandler from "../error";
import NotificationStore from "@/components/NotificationPlugin/NotificationStore";
import FailureAttempts from "@/components/FailureAttempts.vue";

export default {
  name: "admin-management",
  components: {
    DeleteDialog,
    CreateNewAdmin,
    SearchBox,
    Pagination,
    SetPassword,
    LoginAttempts,
    AreYouSure,
    FailureAttempts,
  },
  setup() {
    const adminsList = ref([]);
    const totalAdmins = ref(0);
    const totalPages = ref(1);
    const isMFAEnabled = ref(false);
    const fetchAdmins = async () => {
      const response = await apiManager.getAdmins({ params: filters.value });
      adminsList.value = snakeCaseObjectKeysToCamelCase(response.parsedData.admins);
      totalAdmins.value = response.parsedData.total_items;
      totalPages.value = response.parsedData.total_pages;
      isMFAEnabled.value = response.parsedData.mfa_enabled;
    };

    const adminCreated = () => {
      showAddNewAdmin.value = false;
      changePage(1);
      removeFilters("all");
    };

    const deleteAdmin = (adminID) => {
      showDeleteDialog.value = true;
      deleteDialogKey.value = adminID;
    };
    const adminDeleted = () => {
      showDeleteDialog.value = false;
      deleteDialogKey.value = null;

      if (adminsList.value.length === 1) {
        changePage(adminsPage.value - 1);
      } else {
        fetchAdmins();
      }
    };

    onMounted(async () => {
      await fetchAdmins();
    });

    const showDeleteDialog = ref(false);
    const showAddNewAdmin = ref(false);
    const deleteDialogKey = ref(null);

    // Filters
    const filters = ref({
      username__icontains: "",
      groups__name: null,
      is_active: null,
      active_only: true,
      page: 1,
    });
    const permissionsRadio = ref("");
    const search = ref("");
    const searched = ref(null);
    const removeAll = computed(() => {
      return !(searched.value === null && permissionsRadio.value === "" && isActive.value === true);
    });
    const isActive = ref(true);

    const removeFilters = (filter) => {
      if (filter === "permission" || filter === "all") {
        permissionsRadio.value = "";
        delete filters.value.groups__name;
      }
      if (filter === "search" || filter === "all") {
        search.value = "";
        searched.value = null;
        delete filters.value.username__icontains;
      }
      if (filter === "active_only" || filter === "all") {
        isActive.value = true;
        filters.value.active_only = true;
        delete filters.value.is_active;
      }

      fetchAdmins();
    };

    const doSearch = () => {
      filters.value.username__icontains = search.value;
      if (search.value) {
        searched.value = search.value;
        fetchAdmins();
      } else {
        removeFilters("search");
      }
    };

    onUpdated(() => {
      if (permissionsRadio.value !== "" && filters.value.groups__name !== permissionsRadio.value) {
        filters.value.groups__name = permissionsRadio.value;
        fetchAdmins();
      }

      // Active Only
      const expectedActiveOnly = isActive.value === true;
      const expectedIsActive = isActive.value === false ? "False" : null;
      if (expectedActiveOnly !== filters.value.active_only || expectedIsActive !== filters.value.is_active) {
        filters.value.active_only = expectedActiveOnly;
        filters.value.is_active = expectedIsActive;

        fetchAdmins();
      }
    });

    // Pagination
    const adminsPage = ref(1);
    const changePage = (page) => {
      adminsPage.value = page;
      if (filters.value["page"] !== page) {
        filters.value["page"] = page;

        fetchAdmins();
      }
    };

    // Change Admin Permissions
    const switchPermission = async (adminPk, currentGroups, permission) => {
      const newGroups = ["server_admins", "application_admins", "viewer_admins"].filter(
        (item) =>
          (currentGroups.includes(item) && item !== permission) ||
          (!currentGroups.includes(item) && item === permission)
      );

      if (newGroups.length === 0) {
        NotificationStore.notify({
          message:
            "The admin should have at least 1 permission. Please turn another permission on before removing current permission.",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      const response = await apiManager.patchAdmin(
        camelCaseObjectKeysToSnakeCase({
          params: {
            adminPk: adminPk,
            groups: newGroups,
          },
        })
      );

      if (response.status === 200) await fetchAdmins();
      else if (response.status === 400) {
        NotificationStore.notify({
          message: response.parsedError.groups,
          icon: "info",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else fetchErrorHandler(response.status, response.statusText, "AdminManagement");
    };

    // Change Password
    const showChangePasswordDialog = ref(false);
    const changePasswordAdminPk = ref(-1);

    const changePassword = (admin_pk) => {
      showChangePasswordDialog.value = true;
      changePasswordAdminPk.value = admin_pk;
    };

    const notifySuccess = (msg) => {
      NotificationStore.notify({
        message: msg,
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    };

    // Login Attempts
    const showLoginAttempts = ref(false);
    const currentLoginAttempts = ref([]);
    const showLoginAttemptsTriggerFunction = (adminPk) => {
      const elem = adminsList.value.filter((item) => item.id === adminPk)[0];
      currentLoginAttempts.value = elem.lastAttempts;

      showLoginAttempts.value = true;
    };

    // Revoke TOTP
    const RevokeTOTPId = ref(-1);
    const showRevokeDialog = ref(false);
    const revokeTOTP = async (adminPk) => {
      const response = await apiManager.patchAdmin({
        params: {
          admin_pk: adminPk,
          revoke_totp: true,
        },
      });
      if (response.status === 200) {
        NotificationStore.notify({
          message: "TOTP for this admin revoked successfully.",
          icon: "info",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        await fetchAdmins();
      } else if (response.status === 400) {
        NotificationStore.notify({
          message: response.parsedError,
          icon: "info",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else fetchErrorHandler(response.status, response.statusText, "AdminManagement");
    };

    return {
      fetchAdmins,
      adminsList,
      totalAdmins,
      totalPages,
      isMFAEnabled,

      deleteAdmin,

      adminDeleted,
      showDeleteDialog,
      deleteDialogKey,

      showAddNewAdmin,
      adminCreated,

      // Filters
      filters,
      permissionsRadio,
      isActive,
      search,
      searched,
      removeAll,
      doSearch,
      removeFilters,

      // Pagination
      adminsPage,
      changePage,

      // Patching
      switchPermission,
      showChangePasswordDialog,
      changePasswordAdminPk,
      changePassword,
      notifySuccess,

      // Login Attempts
      showLoginAttempts,
      currentLoginAttempts,
      showLoginAttemptsTriggerFunction,

      // Revoke TOTP
      RevokeTOTPId,
      showRevokeDialog,
      revokeTOTP,
    };
  },
};
</script>
<style lang="scss" scoped>
.is-active {
  .md-icon {
    margin-left: 16px;
    margin-right: 16px;
  }
}

.md-card-header .refresh-btn.md-button {
  margin-left: 0;
}
</style>
